import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonPrimary,
  ConclusionStep
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import { Hiring } from '../../../../services/paid-custody';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaidCustodyCompleted',
  props: {
    dataCompleted: null
  },
  setup(__props: any) {

const { dataCompleted } = __props as {
  dataCompleted: Hiring;
};

const router = useRouter();



const handleNextClick = () => {
  return router.push({ name: 'trade' });
};

return { __sfc: true,router, handleNextClick, NebraskaColors, BaseText, ButtonPrimary, ConclusionStep }
}

})